import React from 'react';
import { Col, Row } from 'antd';

import { KimLiftingHoldingCarryingGenderResult } from '@/hooks';

import { GenderDetailRow } from './GenderDetailRow';
import { RiskSummary } from './utils';

interface GenderRiskResultProps {
	woman: KimLiftingHoldingCarryingGenderResult;
	man: KimLiftingHoldingCarryingGenderResult;
	womanSummary: RiskSummary;
	manSummary: RiskSummary;
}

export function GenderRiskResult(props: Readonly<GenderRiskResultProps>): JSX.Element {
	const { woman, man, womanSummary, manSummary } = props;

	return (
		<Row gutter={[0, 16]}>
			<Col span={24}>
				<GenderDetailRow
					label={'Score for women'}
					score={woman.score}
					risk={woman.risk}
					summary={womanSummary}
				/>
			</Col>
			<Col span={24}>
				<GenderDetailRow label={'Score for men'} score={man.score} risk={man.risk} summary={manSummary} />
			</Col>
		</Row>
	);
}
